import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import {  getDateProduction, getMonthNames} from '../../Services/FechasService';
import {getCalendarioOperativoSemanal, getCalendarioOperativoSemanalPartida,} from '../../API/Global/CalendarioOperativo/CalendarioOperativoRequest';
import { exportarExcel } from '../../Services/ArchivosService';
import { toastShow } from '../../Services/ToastService';
import { setTitlePage } from '../../Services/Config/ConfigService';
import { getDatesProduccionNormal } from '../../Services/Moment/Luxon';
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext';
import { getCalendarioFinanzasMensual } from '../../API/Global/CalendarioFinanzas/CalendarioFinanzasRequest';
import { Toast } from 'primereact/toast';

const CalendarioOperativo = ({ getInfo = () => { }, data = [], setData = () => { }, Nombre, selected, setSelected = () => { },
    dates, setDates, type = 'Month', setIdCalendario = () => { }, loading = false, setLoading = () => { } }) => {

    const { config } = useContext(ConfigContext);
    // const [loading, setLoading] = useState(false);
    const [meses, setMeses] = useState([]);
    const [mes, setMes] = useState(0);
    const toast = useRef(null);

    const obtenerInformacionFechas = async () => {
        setLoading(true)
        setData([])

        if (!dates[0] !== null) {
            if (!dates[1]) {
                toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
            }
            else {
                let fechaFormato = getDateProduction(dates)

                const result = await getInfo(fechaFormato)
                setData(result)
            }

        } else {
            toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
        }

        setLoading(false)
    }


    const filtrarMeses = async (Mes) => {
       
        setMes(Mes)
        let mesSeleccionado = meses.filter((e) => Mes === e.IdCDetalle)

        let rangoFechaInicio = new Date(mesSeleccionado[0]?.FechaInicio)
        let rangoFechaFinal = new Date(mesSeleccionado[0]?.FechaFinal)


        let datosFechas2 = [mesSeleccionado[0]?.FechaInicio, mesSeleccionado[0]?.FechaFinal]
        let datosFechas = [rangoFechaInicio, rangoFechaFinal]
        setDates(datosFechas)

        setIdCalendario(mesSeleccionado[0]?.IdMes)

    }


    const AsignarFechasCalendario = (calendarioMeses) => {
        
        let nowDate = new Date()
        let year = new Date().getFullYear();
        let mes = new Date().getMonth() + 1
        let a = calendarioMeses.filter((e) => mes === e.MesNumero && year === e.Anio)

        let semA = a.filter((s) => {
            if ((new Date(s.FechaInicio) <= nowDate) && (new Date(s.FechaFinal) >= nowDate)) {
                return s
            }
        })
        let mesAnterior = mes === 1 ? (12) : new Date().getMonth()
        let anioAnterior = mes === 1 ? year -1 : year
        let b = calendarioMeses.filter((e) => mesAnterior === e.MesNumero && anioAnterior === e.Anio)
        let semB = b.filter((s) => {
            if ((new Date(s.FechaInicio) <= nowDate) && (new Date(s.FechaFinal) >= nowDate)) {

                return s
            }

        })

        let idM

        if (semA.length <= 0 && semB.length <= 0) {
            // let mesSiguiente = mes + 1
            let mesSiguiente = mes === 12 ? (1) : (mes + 1)
            let anioSiguiente = mes === 12 ? year + 1 : year
            let c = calendarioMeses.filter((e) => mesSiguiente === e.MesNumero && anioSiguiente === e.Anio)
            let semC = c.filter((s) => {
                if (new Date((s.FechaInicio) <= nowDate) && (new Date(s.FechaFinal) >= nowDate)) {
                    return s
                }

            })
            idM = semC[0]?.IdCDetalle
            // setMes(semC[0].IdCDetalle)

        } else {

            if (new Date() <= (new Date(b[b.length - 1]?.FechaFinal))) {
                // setMes(semB[0].IdCDetalle)
                idM = semB[0]?.IdCDetalle
            } else {
                idM = semA[0]?.IdCDetalle
                // setMes(semA[0].IdCDetalle)
            }



        }

        setMes(idM)

        setIdCalendario(idM)

        calendarioMeses.sort((a, b) => {
            // if (a.Anio !== b.Anio) {
            //     return a.Anio - b.Anio; 
            // }

            if (a.anio !== b.anio) {
                return b.anio - a.anio;
            }
            if (a.IdCDetalle >  b.IdCDetalle) {
                return a.NoMes - b.NoMes ;
            }
        
            // return monthOrder[a.MesNumero] - monthOrder[b.MesNumero]; 
        })


        setMeses(calendarioMeses)
    }

    const obtenerCalendarioOperativoMensual = async () => {

        // const resultado = await getCalendarioOperativoMensual()


        // let calendarioMeses = []
        // let language = 'es'
        // calendarioMeses = resultado.map((e) => {
        //     return {
        //         IdCDetalle: e.IdCDetalle,
        //         Mes: getMonthNames((e.Mes - 1), language),
        //         Semanas: e.Semanas,
        //         FechaInicio: (e.FechaInicio),
        //         FechaFinal: (e.FechaFinal),
        //         Anio: e.Ano,
        //         MesRango: getMonthNames((e.Mes - 1), language) + "-" + e.Ano,
        //         MesNumero: e.Mes

        //     }
        // })
        const tempoCalendario = await getCalendarioFinanzasMensual()
        let calendarioMeses = []

        calendarioMeses = tempoCalendario.map((e) => {
            let mesName = config.language === 'es' ? e.MesEsLargo : e.MesEnLargo;
            return {
                IdCDetalle: e.IdMes,
                IdMes: e.IdMes,
                Mes: mesName,
                Semanas: e.NoSemanas,
                FechaInicio: (e.InicioMes),
                FechaFinal: (e.FinMes),
                Anio: e.Anio,
                MesRango: mesName + "-" + e.Anio,
                MesNumero: e.NoMes

            }
        })

      


        AsignarFechasCalendario(calendarioMeses)

    }

    const obtenerCalendarioOperativoMensualPartida = async () => {

        // const resultado = await getCalendarioOperativoMensualPartida()
        const result = await getCalendarioFinanzasMensual()



        let calendarioMeses = []

        calendarioMeses = result.map((e) => {
            let mesName = config.language === 'es' ? e.MesEsLargo : e.MesEnLargo;
            return {
                IdCDetalle: e.IdMes,
                IdMes: e.IdMes,
                Mes: mesName,
                Semanas: e.NoSemanas,
                FechaInicio: (e.InicioMes),
                FechaFinal: (e.FinMes),
                Anio: e.Anio,
                MesRango: mesName + "-" + e.Anio,
                MesNumero: e.NoMes

            }
        })

        AsignarFechasCalendario(calendarioMeses)
    }

    const obtenerCalendarioOperativoSemanal = async () => {
        const resultado = await getCalendarioOperativoSemanal()

        let calendarioMeses = []
        let language = 'es'
        calendarioMeses = resultado.map((e) => {
            return {
                IdCDetalle: e.IdCDetalle,
                Mes: getMonthNames((e.Mes - 1), language),
                Semana: e.Semana,
                FechaInicio: (e.FechaInicio),
                FechaFinal: (e.FechaFinal),
                CuentaSemana: e.CuentaSemana,
                Anio: e.Ano,
                MesRango: getMonthNames((e.Mes - 1), language) + ' ' + 'Semana ' + "- " + e.CuentaSemana,
                MesNumero: e.Mes

            }
        })
        AsignarFechasCalendario(calendarioMeses)
    }

    const obtenerCalendarioOperativoSemanalPartida = async () => {

        const resultado = await getCalendarioOperativoSemanalPartida()
       

        let calendarioMeses = []
        calendarioMeses = resultado.map((e) => {
            let mesName = config.language === 'es' ? e.MesRangoEs : e.MesRangoEn;

            return {
                ...e,
                MesRango: mesName
            }
            // let mesName = config.language === 'es' ? e.MesEsLargo : e.MesEnLargo;
            // return {
            //     IdCDetalle: e.IdSemana,
            //     IdMes: e.IdMes,
            //     Mes: mesName,
            //     Semana: e.NoSemana,
            //     FechaInicio: e.InicioSemana,
            //     FechaFinal: e.FinSemana,
            //     CuentaSemana: e.CuentaSemana,
            //     Anio: e.Anio,
            //     MesRango: mesName + ' Semana - ' + e.CuentaSemana,
            //     MesNumero: e.NoMes
            // }
        })

        let nowDate = new Date()
        let year = nowDate?.getFullYear();
        let mes = new Date().getMonth() + 1

        let a = calendarioMeses.filter((e) => mes === e.MesNumero && year === e.Anio)

        let semA = a.filter((s) => {
            if ((new Date(s.FechaInicio) <= nowDate) && (new Date(s.FechaFinal) >= nowDate) && s.IsMes !== 1) {
                return s
            }
        })
        // let mesAnterior = mes === 1 ? (mes + 1) : new Date().getMonth()
        let mesAnterior = mes === 1 ? (12) : new Date().getMonth()
        let anioAnterior = mes === 1 ? year -1 : year
        let b = calendarioMeses.filter((e) => mesAnterior === e.MesNumero && anioAnterior === e.Anio)
        let semB = b.filter((s) => {
            if ((new Date(s.FechaInicio) <= nowDate) && (new Date(s.FechaFinal) >= nowDate) && s.IsMes !== 1) {

                return s
            }

        })


        if (semA.length <= 0 && semB.length <= 0) {
            let mesSiguiente = mes === 12 ? (1) : (mes + 1)
            let anioSiguiente = mes === 12 ? year + 1 : year
            let c = calendarioMeses.filter((e) => mesSiguiente === e.MesNumero && (e.Anio === anioSiguiente))
            let semC = c.filter((s) => {
                if (new Date((s?.FechaInicio) <= nowDate) && (new Date(s?.FechaFinal) >= nowDate)) {
                    return s
                }

            })
            setMes(semC[0]?.IdCDetalle)

        } else {

            if (new Date() <= (new Date(b[b.length - 1]?.FechaFinal))) {

                setMes(semB[0]?.IdCDetalle)
            } else {
                setMes(semA[0]?.IdCDetalle)
            }



        }

        calendarioMeses.sort((a, b) => {
            // if (a.Anio !== b.Anio) {
            //     return a.Anio - b.Anio; 
            // }
            if (a.anio !== b.anio) {
                return b.anio - a.anio;
            }
            if (a.IdCDetalle >  b.IdCDetalle) {
                return a.NoMes - b.NoMes ;
            }
        
        })

        setMeses(calendarioMeses)



    }
    useEffect(() => {
        let mesSeleccionado = meses.filter((e) => mes === e.IdCDetalle)
        
        if (mes !== 0) {
            filtrarMeses(mes)
        }
    }, [meses])


    useEffect(() => {
        switch (type) {
            case 'Month':
                obtenerCalendarioOperativoMensual()
                break;
            case 'Week':
                obtenerCalendarioOperativoSemanal()
                break;
            case 'WeekPartida':
                obtenerCalendarioOperativoSemanalPartida()
                break;
            case 'MonthPartida':
                obtenerCalendarioOperativoMensualPartida();
                break;
            default:
                obtenerCalendarioOperativoMensual()
                break;
        }
        // obtenerCalendarioOperativoMensual()

        setTitlePage(`${Nombre}`)
        // window.document.title = `PPF • ${Nombre}`;
    }, [])


    useEffect(() => {
        if (dates.length === 2 && dates[0] !== null && dates[1] !== null) {

            obtenerInformacionFechas()

        }
    }, [dates])


    return (
        <div className='d-flex fle-row'>
            <Toast ref={toast} />
            <Dropdown id="IdCDetalle" name="IdCDetalle" style={{ height: 35, width: 220 }} className="mx-2" filter filterBy='MesRango'
                onChange={(e) => filtrarMeses(e.value)} value={mes} optionValue="IdCDetalle" optionLabel="MesRango" options={meses} />
            <Calendar id="range" value={dates} onChange={(e) => setDates(e.value)} showButtonBar showIcon dateFormat='dd/mm/yy'
                selectionMode="range" style={{ height: 35, width: 245 }} />
            <Button className=" mx-2" icon="pi pi-search" loading={loading} onClick={obtenerInformacionFechas} style={{ height: 35 }} />


        </div>
    )
}

export default CalendarioOperativo